export default __webpack_public_path__ + "static/media/_kaasplakken.0bc2997f.png";